import type {ChartData, ChartOptions, ScriptableContext} from 'chart.js';
import {Line} from 'react-chartjs-2';
import {useState, useEffect} from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import useGetPostReport from '../hooks/useGetPostReport';
import moment from 'jalali-moment';
import './style.css';
import DotsLoading from '../../../components/dotsLoading';

ChartJS.register(ChartDataLabels);
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler,
);
ChartJS.defaults.font.family = 'IRANYekanXVF';

type TReportChartProps = {
  guid: string;
};
const options: ChartOptions<'line'> = {
  responsive: true,

  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      title: {
        display: true,
        text: 'تعداد بازدید',
      },
      grid: {
        display: true,
      },
      ticks: {
        precision: 0,
      },
    },
  },
  elements: {
    point: {
      radius: 0,
    },
  },
  plugins: {
    legend: {
      position: 'top' as const,
      display: false,
      labels: {
        font: {
          family: 'IRANSans', // right here
        },
      },
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
  },
};
function createGradient(ctx: CanvasRenderingContext2D) {
  const gradient = ctx.createLinearGradient(0, 0, 0, 250);

  gradient.addColorStop(0, 'rgba(195, 111, 11, 0.3)');
  gradient.addColorStop(1, 'rgba(255,255, 255, 0.00)');

  return gradient;
}
const ReportChart = ({guid}: TReportChartProps) => {
  const [datasets, setDatasets] = useState<ChartData<'line'> | null>(null);

  const {report, isLoading} = useGetPostReport(guid);

  const labels =
    report?.map(x => {
      const now = moment().locale('fa').format('jMM/jDD');
      const chartTime = moment(x.date).locale('fa').format('jMM/jDD');
      return now === chartTime ? 'امروز' : chartTime;
    }) || [];

  useEffect(() => {
    if (!report || report.length === 0) {
      setDatasets(null);
      return;
    }

    let dataPoints = report.map(x => x.view_quantity);

    if (dataPoints.length === 1) {
      dataPoints = [dataPoints[0], dataPoints[0]];
    }

    setDatasets({
      labels: labels.length === 1 ? ['', labels[0]] : labels,
      datasets: [
        {
          data: dataPoints,
          borderColor: '#C36F0B',
          backgroundColor: (context: ScriptableContext<'line'>) =>
            createGradient(context.chart.ctx),
          fill: true,
          datalabels: {
            anchor: 'center',
            align: 'top',
            offset: 2,
          },
        },
      ],
    });
  }, [report]);

  return (
    <div className="flex w-full flex-col">
      <div className="flex items-center gap-2">
        <div className="rounded-full w-[8px] h-[8px] bg-warning-600" />
        <p className="text-sm font-Medium m-0 p-0">
          آمار بازدید (کل بازدید:
          {report &&
            report.reduce((partialSum, a) => partialSum + a.view_quantity, 0)}
          )
        </p>
      </div>
      <div className="flex items-center">
        <div className="w-full">
          {isLoading ? (
            <DotsLoading />
          ) : (
            <>{datasets && <Line options={options} data={datasets} />}</>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportChart;
